import '@/assets/styles.scss';
import '@/assets/theme/theme.scss';
import VueGoogleMaps from '@fawmi/vue-google-maps';
import '@popperjs/core';
import 'bootstrap';
import 'jquery';
import "moment/locale/pt-br";
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import App from './App.vue';
import AppContainer from './components/AppContainer.vue';
import Navbar from './components/navbar/Navbar.vue';
import PageTitle from './components/PageTitle.vue';
import SubmitBtn from './components/SubmitBtn.vue';
import TabBackBtn from './components/TabBackBtn.vue';
import Tabbar from './components/tabbar/Tabbar.vue';
import './registerServiceWorker';
import router from './router';
import paths from './router/paths';
import AppLoading from './components/AppLoading.vue';
import { vMaska } from "maska/vue"
import money from 'v-money3'
import EmptyState from './components/EmptyState.vue';

const app = createApp(App)
app.directive('maska', vMaska)
app.config.globalProperties.$paths = paths;
app.component('AppContainer', AppContainer)
app.component('AppLoading', AppLoading)
app.component('Navbar', Navbar)
app.component('Tabbar', Tabbar)
app.component('EmptyState', EmptyState)
app.component('SubmitBtn', SubmitBtn)
app.component('PageTitle', PageTitle)
app.component('TabBackBtn', TabBackBtn)
app.use(createPinia())
app.use(money)

app.use(VueGoogleMaps, {
    load: {
        key: process.env.VUE_APP_GOOGLE_MAPS_KEY
    },
})
app.use(router).mount('#app')
